import { IoMdMenu } from "react-icons/io";
import { IoRefresh, IoRestaurant } from "react-icons/io5";
import { useFetchOrdersQuery, useTypedSelector } from "../store";
import RadioButton from "../components/common/Radio";

interface HeaderProps {
  setMenuOpen: (value: boolean) => void;
}

const Header: React.FC<HeaderProps> = ({ setMenuOpen }) => {
  const restaurant = useTypedSelector((state) => state.session.restaurant);
  const { refetch, isFetching } = useFetchOrdersQuery();

  return (
    <div className="w-full flex justify-between items-center bg-white border-b shadow-sm h-14 px-4 z-20 sticky top-0">
      <div className="flex gap-2 items-center">
        <button
          className="p-1.5 rounded-full hover:bg-gray-100 text-gray-600 transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            setMenuOpen(true);
          }}
        >
          <IoMdMenu className="text-xl" />
        </button>

        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-primary/10 flex items-center justify-center">
            <IoRestaurant className="text-primary text-base" />
          </div>
          <span className="text-gray-800 font-bold text-base truncate max-w-[150px] sm:max-w-none">
            {restaurant?.displayName || "Restaurant Dashboard"}
          </span>
        </div>
      </div>

      <div className="flex gap-2 items-center">
        <div className="hidden sm:flex items-center gap-2 px-2 py-1 bg-gray-50 rounded-lg border border-gray-200">
          <span className="text-xs font-medium text-gray-500">Statut:</span>
          <RadioButton />
        </div>

        <button
          onClick={() => refetch()}
          disabled={isFetching}
          className={`
            flex items-center gap-1.5 px-3 py-1.5 rounded-lg font-semibold transition-all text-sm
            ${
              isFetching
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-primary text-white hover:bg-red-600 shadow-sm hover:shadow active:scale-95"
            }
          `}
        >
          <IoRefresh
            className={`text-lg ${isFetching ? "animate-spin" : ""}`}
          />
          <span className="hidden sm:inline">{isFetching ? "Actualisation..." : "Actualiser"}</span>
        </button>
      </div>
    </div>
  );
};

export default Header;
